// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-azap","hero_picture":"Header_hero_picture__q8zDg","hero_img":"Header_hero_img__cmvV2"};